const catagoryData = [
  {
    name: "men's clothing",
    title: "Clothes",
    img: "https://fakestoreapi.com/img/71-3HjGNDUL._AC_SY879._SX._UX._SY._UY_.jpg",
  },

  {
    name: "electronics",
    title: "Electronics",
    img: "https://fakestoreapi.com/img/61mtL65D4cL._AC_SX679_.jpg",
  },
  {
    name: "women's clothing",
    title: "women's Cotton Jacket",
    img: "https://fakestoreapi.com/img/71HblAHs5xL._AC_UY879_-2.jpg",
  },
  {
    name: "jewelery",
    title: "jewelery",
    img: "https://fakestoreapi.com/img/71YAIFU48IL._AC_UL640_QL65_ML3_.jpg",
  },
];
export default catagoryData;
